import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import classNames from 'classnames';
import { SlRichText } from '../SlRichText/SlRichText';

import s from './SlNote.scss';
import { NoteComponentLevel } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';
import { SlNoteWarningIcon } from './SlNoteWarningIcon';
import { SlNoteInfoIcon } from './SlNoteInfoIcon';

// Temporary icon change
interface ISlNoteProps {
	content: string;
	level: NoteComponentLevel;
}

export function SlNote({
	content,
	level = NoteComponentLevel.Info,
}: ISlNoteProps): JSX.Element {
	useStyles(s);

	const iswarning = level === NoteComponentLevel.Error || level === NoteComponentLevel.Warning;

	return (
		<div
			className={classNames('sl-note', {
				warning: iswarning,
			})}
			sl-test-data="cmpSlNote"
		>
			<div className="sl-note__icon">
				{iswarning ? <SlNoteWarningIcon /> : <SlNoteInfoIcon />}
			</div>
			<div className="sl-note__content">
				<SlRichText content={content} />
			</div>
		</div>
	);
}
